import { Markup } from "interweave";
import { DictionaryLink, Language, Sentence } from "../../../rest/models";
import { useAppSelector } from "../../../store/hooks";
import { getModelMap } from "../../../rest/slice";
import { RenderSentenceTranslation } from "./RenderSentenceTranslation";
import { RenderDictionaryLink } from "./RenderDictionaryLink";

export function RenderSentenceTranslations(props: Props)
{
    const sen = props.sentence;
    const dls = props.dictLinks;

    const langModels = getModelMap(useAppSelector, Language) ?? {};
    const bookLangs = useAppSelector(state => state.bookReader.bookLangs);

    let elmTranslations = <></>;
    if (sen.type === 'n' && sen.html)
    {
        elmTranslations = <Markup content={sen.html}/>
    }
    else
    {
        const tlElms = bookLangs
            .filter(bl => langModels[bl.language])
            .map(function(bl)
            {
                const lang = langModels[bl.language];
        
                return <RenderSentenceTranslation
                    key={bl.key}
                    dictLinks={props.dictLinks[bl.language]}
                    language={lang}
                    sentence={sen}/>;
            });
        elmTranslations = <>{tlElms}</>;
    }
    
    const dlsNoLang = dls[''] || [];
    const dlsNoLangRow = (dlsNoLang.length && sen.type !== 'n')
        ? <div>{dlsNoLang.map(dl => <RenderDictionaryLink key={dl.key} dl={dl}/>)}</div>
        : <></>;
    return (
    <>
        {elmTranslations}
        {dlsNoLangRow}
    </>);
}

interface Props
{
    sentence: Sentence;
    dictLinks: {[language_id: string]: DictionaryLink[]};
}